export default __webpack_public_path__ + "static/media/shap-02.1e0dd239.svg";